import { graphql } from 'react-relay';

export const nftPublicProfileAddressEntryQuery = graphql`
    query nftPublicProfileAddressEntryQuery(
        $username: String = ""
        $walletAddress: String!
        $creationsFirst: Int = 20
        $creationsCursor: String
        $collectionFirst: Int = 20
        $collectionCursor: String
        $liveAuctionsFirst: Int = 20
        $liveAuctionsCursor: String
        $liveBidsFirst: Int = 20
        $liveBidsCursor: String
        $lostBidsFirst: Int = 20
        $lostBidsCursor: String
        $draftsFirst: Int = 0
        $draftsCursor: String
        $fetchDrafts: Boolean = false
        $tokenContractId: String = ""
        $hasTokenContractId: Boolean = false
        $userId: String = ""
        $fetchUser: Boolean = false
    ) {
        viewer {
            publicProfileByWalletAddress(walletAddress: $walletAddress) {
                username
            }
            nftUserIdByWalletAddress(walletAddress: $walletAddress)
            ...NftPublicProfileAddressRespLayout_viewer
            ...NftHeaderLayout_viewer
            ...collectorTabConfig_viewer @relay(mask: false)
            ...profileRouteMetadata_viewer @relay(mask: false)
        }
    }
`;
